var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfwrap"},[_c('embed',{staticClass:"pdf",attrs:{"type":"application/pdf","src":_vm.ruta+'#toolbar=0&navpanes=0&scrollbar=1'}})])}
var staticRenderFns = []

export { render, staticRenderFns }